import { paths } from '@/app/router/paths'

/** The link the invitee opens. Built here because the server only returns the token. */
export function invitationLink(token: string): string {
  return `${window.location.origin}${paths.invitation(token)}`
}
